<script setup lang="ts">
import TopNavbar from '@/layout/components/topNavbar/TopNavbar.vue';
import ContentFooter from '@/layout/components/ContentFooter.vue';
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';

const { isAuthenticated, loading } = useAuth();

</script>

<template>
  <template v-if="!loading && isAuthenticated">
    <top-navbar :hideNoticeIcon="true"/>
    <router-view/>
    <content-footer />
  </template>
</template>

<style scoped>
.contentloading {
  position: relative;
  height: 100%;
  width: 100%;
}

.contentLoading > div {
  position: absolute;
  background-color: rgba(80, 80, 80, 0.5);
  height: 100%;
  width: 100%;
  z-index: 1001;
}
.contentLoading > div > label {
  font-weight: bold;
  color: white;
  position: absolute;
  top: 300px;
  left:40%;
  transform: translateY(-50%) translateX(-50%);
}
</style>
